export default "/images/Venue2.png?d6d65ff769f7c465fff2f71e087c67d0";